import { gql } from '@apollo/client';

export const CORE_TOOL_CATEGORY_FIELDS = gql`
  fragment CoreToolCategoryFields on ToolCategory {
    id
    name
    toolHoundId
    toolTypeId
  }
`;

export const GET_TOOL_CATEGORIES = gql`
  query ToolCategoryGroupByName {
    toolCategoryGroupByName {
      id
      name
      toolCategoryStats {
        consumablesCount
        toolsCount
      }
    }
  }
`;
